import { className } from '@empori/util';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Direction } from '../../util/util';
import { Autoplay, SwiperOptions } from 'swiper';
import { LogotypesProps, slidesPerView } from './logotypes';
import { NavigationButton } from './logotypesNavigation';
import { Logotype } from './logotypeImg';

export function LogotypesSlideshow(props: LogotypesProps) {

  const {
    mediaObjects,
    autoplay,
    filterColor,
    externalLink,
    hideNavigation,
    logotypesPerView,
    maxHeight,
    spaceBetween
  } = props.data;

  const spv = slidesPerView(logotypesPerView);

  const settings: SwiperOptions = {
    modules: autoplay ? [ Autoplay ] : [],
    autoplay: autoplay ? { delay: 3000 } : false,
    loop: true,
    autoHeight: true,
    lazy: true,
    loopedSlidesLimit: false,
    breakpoints: {
      800: { // 800px or more
        slidesPerView: spv,
        spaceBetween: spaceBetween
      },
      600: {
        slidesPerView: spv > 4 ? 4 : spv,
        spaceBetween: 20
      },
      440: {
        slidesPerView: spv > 3 ? 3 : spv
      },
      300: {
        slidesPerView: spv > 2 ? 2 : spv
      },
      0: {
        slidesPerView: 1
      }
    }
  };

  return(
    <Swiper {...settings}>
      {mediaObjects.map((item, index) =>
        <SwiperSlide key={index}>
          <Logotype
            {...item}
            externalLink={externalLink ?? false}
            maxHeight={maxHeight}
            filterColor={filterColor} />
        </SwiperSlide>)}
      {!hideNavigation &&
        <div className='empori-slideshow-navigation element-flex'>
          <NavigationButton direction={Direction.prev} />
          <NavigationButton direction={Direction.next} />
        </div>}
    </Swiper>
  );
}